import { render, staticRenderFns } from "./deleteReportCustomGroup.vue?vue&type=template&id=2b689da7"
import script from "./deleteReportCustomGroup.vue?vue&type=script&lang=js"
export * from "./deleteReportCustomGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports